<template>
    <div class="p-3">
        <div class="text-sm text-muted text-uppercase">
            {{ label }}
        </div>

        <div class="text-lg text-blue-600 font-weight-bold">
            {{ departureDate }} {{ departureTime }}
        </div>

        <div>
            {{ startPlace }} - {{ endPlace }}
        </div>

        <div class="mt-2 text-blue-600 font-weight-bold text-right">
            {{ $t('price') }}:
        </div>

        <div class="mt-1 text-blue-600 font-weight-bold" v-if="false">
            <div
                class="d-flex align-items-center justify-content-between"
                v-for="(passenger, idx) in passengersAboveOne"
                :key="idx"
            >
                <div>
                    {{ $t(`berbus.components.cart.passenger_types.${passenger.type}`) }}:
                </div>

                <div class="text-nowrap text-right">
                    {{ passenger.quantity }}
                    x
                    <span class="text-lg">{{ formatPrice(getTravelPriceByPassengerType(passenger.type), travel.currency) }}</span>
                </div>
            </div>
        </div>

        <div class="mt-1 text-blue-600 font-weight-bold">
            <div
                class="d-flex align-items-center justify-content-between"
            >
                <div>
                    {{ $t('taxi.components.cart.base_price') }}:
                </div>

                <div class="text-nowrap text-right">
                    <span class="text-lg">{{ formatPrice(this.getTravelTotal, travel.currency) }}</span>
                </div>
            </div>
        </div>

        <cart-additional-options />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CartAdditionalOptions from './CartAdditionalOptions';

    export default {
        components: {
            CartAdditionalOptions,
        },

        props: {
            label: {
                type: String,
                required: true,
            },

            departureDate: {
                type: String,
                required: true,
            },

            departureTime: {
                type: String,
                required: true,
            },

            startPlace: {
                type: String,
                required: true,
            },

            endPlace: {
                type: String,
                required: true,
            },

            travel: {
                type: Object,
                required: true,
            },
        },

        computed: {
            ...mapGetters({
                additionalOptionsTotal: 'berbus/additionalOptionsTotal',
                getTravelTotal: 'berbus/getTravelTotal',
                search: 'berbus/search',
                getTravelPriceByPassengerType: 'berbus/getTravelPriceByPassengerType',
            }),

            passengersAboveOne() {
                return this.search.passengers.filter((passenger) => {
                    return passenger.quantity > 0;
                });
            },
        },
    };
</script>
